import {
  BaseballEventDetailId,
  CommonEventDetailId,
} from '@collector/sportsapi-client-legacy'

import { EventInfoControls } from '../../configuration'

export const eventInfoControls: EventInfoControls = [
  {
    grid: {
      cols: '2',
      controls: [
        {
          eventDetailId: BaseballEventDetailId.WeatherConditions,
          label: 'Weather cond.',
        },
        {
          eventDetailId: BaseballEventDetailId.PitchConditions,
          label: 'Pitch cond.',
        },
      ],
    },
  },
  {
    grid: {
      class: '',
      cols: '3',
      controls: [
        {
          eventDetailId: CommonEventDetailId.HasLineups,
        },
        {
          eventDetailId: BaseballEventDetailId.Half,
        },
        {
          eventDetailId: BaseballEventDetailId.MercyRule,
          wide: true,
        },
      ],
    },
  },
  {
    grid: {
      cols: '3',
      controls: ['empty', 'InvertedParticipantsSwitch', 'TeamColorsSwitch'],
    },
  },
]
